export default __webpack_public_path__ + "static/media/sidebar-4.68fe3873.png";